import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _sendBIEventRequest = {};
var _sendBIEventResponse = {};
function resolveComWixpressMarketAimApiBiEventsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/app-instance-manager-webapp',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/apps',
                destPath: '',
            },
        ],
        'wixapis.com': [
            {
                srcPath: '/apps',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
            {
                srcPath: '/api/v1/instance',
                destPath: '/v1/instance',
            },
            {
                srcPath: '/api/v1/scripts',
                destPath: '/v1/scripts',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Submit a BI event to Wix. */
export function sendBiEvent(payload) {
    var _a = serializer(_sendBIEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendBIEventResponse, {}).fromJSON;
    function __sendBiEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.bi_events.v1.send_bi_event_response',
            method: 'POST',
            methodFqn: 'com.wixpress.market.aim.api.BIEventsService.sendBIEvent',
            url: resolveComWixpressMarketAimApiBiEventsServiceUrl({
                protoPath: '/v1/bi-event',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendBiEvent.fromReq = fromReq;
    __sendBiEvent.__isAmbassador = true;
    return __sendBiEvent;
}
//# sourceMappingURL=http.impl.js.map